<template>
  <div class="flex flex-row px-3xl py-lg justify-between items-center">
    <div class="flex items-center gap-4">
      <ItemsPerPageSelector
        :per-page="perPage"
        :per-page-options="perPageOptions"
        @update:perPage="updatePerPage"
      />
      <Divider orientation="vertical" class="h-8" />
      <PaginationInfo :total="total" :per-page="perPage" :page="page" />
    </div>
    <div class="flex items-center gap-1.5">
      <PaginationControls
        :page="page"
        :total-pages="totalPages"
        @update:page="updatePage"
      />
      <Divider v-if="$slots.actions" orientation="vertical" class="h-8" />
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script setup>
// Vue utilities
import { computed } from "vue";

// Custom components
import {
  ItemsPerPageSelector,
  PaginationInfo,
  PaginationControls,
} from "@/SharedComponents/Pagination";
import { Divider } from "@/SharedComponents/Divider";

// Define Props
const props = defineProps({
  total: Number,
  perPage: Number,
  page: Number,
  perPageOptions: {
    type: Array,
    default: () => [15, 25, 50],
  },
});

// Define Emits
const emit = defineEmits(["update:perPage", "update:page"]);

// Computed Props
const totalPages = computed(() => Math.ceil(props.total / props.perPage));

// Functions
const updatePerPage = (newPerPage) => {
  emit("update:perPage", newPerPage);
};

const updatePage = (newPage) => {
  emit("update:page", newPage);
};
</script>
